import { render, staticRenderFns } from "./FileCategoryText.vue?vue&type=template&id=4acfdc96&scoped=true&"
import script from "./FileCategoryText.vue?vue&type=script&lang=js&"
export * from "./FileCategoryText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acfdc96",
  null
  
)

export default component.exports